import React from 'react';
import CmsPage from './CmsPage';
import {DieselRoute} from 'epic-diesel-common/src/hocs';

const CmsPageView = () => <CmsPage />;

export default DieselRoute(CmsPageView, {path: 'page/:slug'});
